import {
  ADD_SALARY_ADVANCE_REQUEST_REQUEST,
  ADD_SALARY_ADVANCE_REQUEST_SUCCESS,
  ADD_SALARY_ADVANCE_REQUEST_FAILURE,
  FETCH_SALARY_ADVANCE_REQUESTS_REQUEST,
  FETCH_SALARY_ADVANCE_REQUESTS_SUCCESS,
  FETCH_SALARY_ADVANCE_REQUESTS_FAILURE,
  FETCH_SALARY_ADVANCE_DETAILS_REQUEST,
  FETCH_SALARY_ADVANCE_DETAILS_SUCCESS,
  FETCH_SALARY_ADVANCE_DETAILS_FAILURE,
  UPDATE_SALARY_ADVANCE_REQUEST_REQUEST,
  UPDATE_SALARY_ADVANCE_REQUEST_SUCCESS,
  UPDATE_SALARY_ADVANCE_REQUEST_FAILURE,
  DELETE_SALARY_ADVANCE_REQUEST_REQUEST,
  DELETE_SALARY_ADVANCE_REQUEST_SUCCESS,
  DELETE_SALARY_ADVANCE_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  ADD_COMMENT_REQUEST_REQUEST,
  ADD_COMMENT_REQUEST_SUCCESS,
  ADD_COMMENT_REQUEST_FAILURE,
  SUBMIT_SALARY_REQUEST_REQUEST,
  SUBMIT_SALARY_REQUEST_SUCCESS,
  SUBMIT_SALARY_REQUEST_FAILURE,
  FETCH_SALARY_ADVANCE_VOUCHERS_REQUEST,
  FETCH_SALARY_ADVANCE_VOUCHERS_SUCCESS,
  FETCH_SALARY_ADVANCE_VOUCHERS_FAILURE,
  CLEAR_SALARY_ADVANCE_REQUESTS_ERROR,
  ADD_CLOSE_REQUEST_REQUEST,
  ADD_CLOSE_REQUEST_SUCCESS,
  ADD_CLOSE_REQUEST_FAILURE,
} from "./salaryAdvanceRequestActionTypes";
import api from "../../api/api";
import { toast } from "react-toastify";

const handleError = (error) => {
  const errorDetails = error.response?.data || error.request || error.message;
  console.error("API Error Details:", errorDetails);
  if (error.response) {
    if (error.response.data?.errors) {
      const validationErrors = Object.values(error.response.data.errors)
        .flat()
        .join("; ");
      return (
        validationErrors ||
        error.response.data?.message ||
        `Error ${error.response.status}: ${error.response.statusText}`
      );
    }
    return (
      error.response.data?.message ||
      `Error ${error.response.status}: ${error.response.statusText}`
    );
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

export const addSalaryAdvanceRequest = (requestData) => async (dispatch) => {
  dispatch({ type: ADD_SALARY_ADVANCE_REQUEST_REQUEST });
  const requestBody = {
    userId: requestData.userId,
    requestTypeId: requestData.requestType,
    amount: requestData.amount,
    currency: requestData.currency,
    isOnSaved: requestData.isOnSaved,
    purpose: requestData.purpose || "",
  };
  try {
    console.log("API - addSalaryAdvanceRequest payload:", requestBody);
    const response = await api.post("/SalaryAdvance", requestBody, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - addSalaryAdvanceRequest response:", response.data);
    dispatch({
      type: ADD_SALARY_ADVANCE_REQUEST_SUCCESS,
      payload: response.data,
    });
    toast.success("Salary Advance Request created successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - addSalaryAdvanceRequest error:", errorMessage);
    dispatch({
      type: ADD_SALARY_ADVANCE_REQUEST_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchSalaryAdvanceRequest = (requestId) => async (dispatch) => {
  dispatch({ type: FETCH_SALARY_ADVANCE_REQUESTS_REQUEST });
  try {
    console.log("API - fetchSalaryAdvanceRequest requestId:", requestId);
    const response = await api.get(`/SalaryAdvance/${requestId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - fetchSalaryAdvanceRequest response:", response.data);
    dispatch({
      type: FETCH_SALARY_ADVANCE_REQUESTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchSalaryAdvanceRequest error:", errorMessage);
    dispatch({
      type: FETCH_SALARY_ADVANCE_REQUESTS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchSalaryAdvanceDetails =
  (requestId, paymentCode) => async (dispatch) => {
    dispatch({ type: FETCH_SALARY_ADVANCE_DETAILS_REQUEST });
    try {
      if (!requestId || isNaN(requestId)) {
        throw new Error("Invalid requestId");
      }
      const cleanRequestId = String(requestId).trim();
      console.log("API - fetchSalaryAdvanceDetails requestId:", cleanRequestId);
      const response = await api.get(`/SalaryAdvance/${cleanRequestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log(
        "API - fetchSalaryAdvanceDetails response:",
        response.data.paymentCode,
        response.data,
      );
      dispatch({
        type: FETCH_SALARY_ADVANCE_DETAILS_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - fetchSalaryAdvanceDetails error:", errorMessage);
      dispatch({
        type: FETCH_SALARY_ADVANCE_DETAILS_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const updateSalaryAdvanceRequest1 =
  (requestId, updatedData) => async (dispatch) => {
    dispatch({ type: UPDATE_SALARY_ADVANCE_REQUEST_REQUEST });
    try {
      console.log("API - updateSalaryAdvanceRequest payload:", updatedData);
      const response = await api.put(
        `/SalaryAdvance/${requestId}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json-patch+json",
            Accept: "*/*",
          },
        },
      );
      console.log("API - updateSalaryAdvanceRequest response:", response.data);
      dispatch({
        type: UPDATE_SALARY_ADVANCE_REQUEST_SUCCESS,
        payload: response.data,
      });
      toast.success("Salary Advance Request updated successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - updateSalaryAdvanceRequest error:", errorMessage);
      dispatch({
        type: UPDATE_SALARY_ADVANCE_REQUEST_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const updateSalaryAdvanceRequest =
  (requestId, updatedData) => async (dispatch) => {
    dispatch({ type: UPDATE_SALARY_ADVANCE_REQUEST_REQUEST });
    try {
      const requestBody = {
        userId: updatedData.userId,
        requestTypeId: updatedData.requestTypeId,
        amount: updatedData.amount,
        currency: updatedData.currency,
        isOnSaved: updatedData.isOnSaved,
        purpose: updatedData.purpose,
      };
      console.log("API - updateSalaryAdvanceRequest payload:", requestBody);
      const response = await api.put(
        `/SalaryAdvance/${requestId}`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json-patch+json",
            Accept: "*/*",
          },
        },
      );
      console.log("API - updateSalaryAdvanceRequest response:", response.data);
      dispatch({
        type: UPDATE_SALARY_ADVANCE_REQUEST_SUCCESS,
        payload: response.data,
      });
      toast.success("Salary Advance Request updated successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - updateSalaryAdvanceRequest error:", {
        message: errorMessage,
        response: error.response?.data,
        status: error.response?.status,
      });
      dispatch({
        type: UPDATE_SALARY_ADVANCE_REQUEST_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const deleteSalaryAdvanceRequest = (requestId) => async (dispatch) => {
  dispatch({ type: DELETE_SALARY_ADVANCE_REQUEST_REQUEST });
  try {
    console.log("API - deleteSalaryAdvanceRequest requestId:", requestId);
    await api.delete(`/SalaryAdvance/${requestId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/*",
      },
    });
    console.log("API - deleteSalaryAdvanceRequest success:", requestId);
    dispatch({
      type: DELETE_SALARY_ADVANCE_REQUEST_SUCCESS,
      payload: requestId,
    });
    toast.success("Salary Advance Request deleted successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - deleteSalaryAdvanceRequest error:", errorMessage);
    dispatch({
      type: DELETE_SALARY_ADVANCE_REQUEST_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const approveSalaryAdvance = (requestId, userId) => async (dispatch) => {
  dispatch({ type: ADD_APPROVE_REQUEST_REQUEST });
  try {
    console.log("API - approveSalaryAdvance requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/approve/${requestId}?userId=${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - approveSalaryAdvance response:", response.data);
    dispatch({ type: ADD_APPROVE_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance approved successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - approveSalaryAdvance error:", errorMessage);
    dispatch({ type: ADD_APPROVE_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const attestSalaryAdvance = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_ATTEST_REQUEST_REQUEST });
  try {
    console.log("API - attestSalaryAdvance requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/attest/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - attestSalaryAdvance response:", response.data);
    dispatch({ type: ADD_ATTEST_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance attested successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - attestSalaryAdvance error:", errorMessage);
    dispatch({ type: ADD_ATTEST_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const verifySalaryAdvance = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_VERIFY_REQUEST_REQUEST });
  try {
    console.log("API - verifySalaryAdvance requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/verify/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - verifySalaryAdvance response:", response.data);
    dispatch({ type: ADD_VERIFY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance verified successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - verifySalaryAdvance error:", errorMessage);
    dispatch({ type: ADD_VERIFY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const rejectSalaryAdvance = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_REJECT_REQUEST_REQUEST });
  try {
    console.log("API - rejectSalaryAdvance requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/reject/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - rejectSalaryAdvance response:", response.data);
    dispatch({ type: ADD_REJECT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance rejected successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - rejectSalaryAdvance error:", errorMessage);
    dispatch({ type: ADD_REJECT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const paySalaryAdvance =
  (requestId, paymentCode, requiresReceipt, userId) => async (dispatch) => {
    dispatch({ type: ADD_PAY_REQUEST_REQUEST });
    try {
      console.log("API - paySalaryAdvance payload:", {
        requestId,
        paymentCode,
        requiresReceipt,
      });
      const response = await api.post(
        `/SalaryAdvance/pay?userId=${userId}`,
        {
          requestId,
          paymentCode,
          requiresReceipt,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json-patch+json",
            Accept: "*/*",
          },
        },
      );
      console.log("API - paySalaryAdvance response:", response.data);
      dispatch({ type: ADD_PAY_REQUEST_SUCCESS, payload: response.data });
      toast.success("Salary Advance paid successfully");
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - paySalaryAdvance error:", errorMessage);
      dispatch({ type: ADD_PAY_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const querySalaryAdvance = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - querySalaryAdvance requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/query/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - querySalaryAdvance response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance queried successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - querySalaryAdvance error:", errorMessage);
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const querySalaryAdvanceComment = (payload) => async (dispatch) => {
  dispatch({ type: ADD_QUERY_REQUEST_REQUEST });
  try {
    console.log("API - querySalaryAdvanceComment payload:", payload);
    const response = await api.post(`/SalaryAdvance/query`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - querySalaryAdvanceComment response:", response.data);
    dispatch({ type: ADD_QUERY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Query comment submitted successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - querySalaryAdvanceComment error:", errorMessage);
    dispatch({ type: ADD_QUERY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const commentSalaryAdvanceReject = (payload) => async (dispatch) => {
  dispatch({ type: ADD_COMMENT_REQUEST_REQUEST });
  try {
    console.log("API - commentSalaryAdvanceReject payload:", payload);
    const response = await api.post(`/SalaryAdvance/reject`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json-patch+json",
        Accept: "*/*",
      },
    });
    console.log("API - querySalaryAdvanceComment response:", response.data);
    dispatch({ type: ADD_COMMENT_REQUEST_SUCCESS, payload: response.data });
    toast.success("Reject comment submitted successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - commentSalaryAdvanceReject error:", errorMessage);
    dispatch({ type: ADD_COMMENT_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const submitSalaryAdvanceRequest = (requestId) => async (dispatch) => {
  dispatch({ type: SUBMIT_SALARY_REQUEST_REQUEST });
  try {
    console.log("API - submitSalaryAdvanceRequest requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/submit/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - submitSalaryAdvanceRequest response:", response.data);
    dispatch({ type: SUBMIT_SALARY_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance submitted successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - submitSalaryAdvanceRequest error:", errorMessage);
    dispatch({ type: SUBMIT_SALARY_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const closeSalaryAdvance = (requestId) => async (dispatch) => {
  dispatch({ type: ADD_CLOSE_REQUEST_REQUEST });
  try {
    console.log("API - closeSalaryAdvance requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/close/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - closeSalaryAdvance response:", response.data);
    dispatch({ type: ADD_CLOSE_REQUEST_SUCCESS, payload: response.data });
    toast.success("Salary Advance closed successfully");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - closeSalaryAdvance error:", errorMessage);
    dispatch({ type: ADD_CLOSE_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchSalaryAdvanceVouchers =
  (voucherId, paymentCode, documentType) => async (dispatch) => {
    dispatch({ type: FETCH_SALARY_ADVANCE_VOUCHERS_REQUEST });
    try {
      if (!voucherId || isNaN(voucherId)) {
        throw new Error("Invalid voucherId");
      }
      if (
        !documentType ||
        typeof documentType !== "string" ||
        documentType.trim() === ""
      ) {
        throw new Error("Invalid or missing documentType");
      }
      const cleanDocumentType = documentType.trim();
      const cleanVoucherId = String(voucherId).trim();
      const url = `/SalaryAdvance/view-voucher/${cleanVoucherId}?documentType=${decodeURIComponent(cleanDocumentType)}`;
      console.log("API - fetchSalaryAdvanceVouchers URL:", url);
      const response = await api.get(url, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log("API - fetchSalaryAdvanceVouchers response:", {
        status: response.status,
        headers: response.headers,
        dataType: response.data.type,
        dataSize: response.data.size,
      });

      if (!response.data || response.data.size === 0) {
        throw new Error("No PDF data received from the server");
      }
      if (response.data.type !== "application/pdf") {
        throw new Error(
          `Invalid response type: expected application/pdf, got ${response.data.type}`,
        );
      }

      const pdfUrl = URL.createObjectURL(response.data);
      const filename =
        response.headers["content-disposition"]?.match(
          /filename=(?:"([^"]+)"|(\S+))/,
        )?.[1] || `SalaryAdvance_${paymentCode}.pdf`;
      const payload = { url: pdfUrl, filename };

      dispatch({ type: FETCH_SALARY_ADVANCE_VOUCHERS_SUCCESS, payload });
      return payload;
    } catch (error) {
      const errorMessage = handleError(error);
      console.error("API - fetchSalaryAdvanceVouchers error:", errorMessage);
      if (error.response?.status === 404) {
        console.warn(
          "API - fetchSalaryAdvanceVouchers: Voucher not found, returning empty payload",
        );
        const payload = { url: null, filename: null };
        dispatch({ type: FETCH_SALARY_ADVANCE_VOUCHERS_SUCCESS, payload });
        return payload;
      }
      dispatch({
        type: FETCH_SALARY_ADVANCE_VOUCHERS_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      throw error;
    }
  };

export const submitSalaryAdvance = (requestId) => async (dispatch) => {
  dispatch({ type: SUBMIT_SALARY_REQUEST_REQUEST });
  try {
    console.log("API - submitSalaryAdvanceRequest requestId:", requestId);
    const response = await api.post(
      `/SalaryAdvance/submit/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json-patch+json",
          Accept: "*/*",
        },
      },
    );
    console.log("API - submitSalaryAdvanceRequest response:", response.data);
    dispatch({
      type: SUBMIT_SALARY_REQUEST_SUCCESS,
      payload: response.data,
    });
    toast.success("Salary Advance request submitted successfully.");
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - submitSalaryAdvanceRequest error:", errorMessage);
    dispatch({
      type: SUBMIT_SALARY_REQUEST_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const clearSalaryAdvanceRequestsError = () => ({
  type: CLEAR_SALARY_ADVANCE_REQUESTS_ERROR,
});
